<template>
  <div class="page">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <van-tabs v-model="active1" v-show="flag">
      <van-tab title="个人用户">
      </van-tab>
      <van-tab title="单位用户">
      </van-tab>
    </van-tabs>

    <van-form @submit="userOnSubmit" v-show="active1 == 0">
      <van-cell-group title="申请信息">
        <van-field readonly required clickable :value="form.fpactno" label="缴费号" placeholder="请选择缴费号" :rules="[{ required: true, message: '点击选择缴费号' }]">
          <template v-if="!$route.query.readonly" #button>
            <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
          </template>
        </van-field>
        <van-field readonly v-model="form.foldname" label="用户名称" />
        <van-field readonly v-model="form.foldaddr" label="用水地址" />
      </van-cell-group>

      <van-cell-group title="变更信息(只需输入更改的信息)">
        <!-- <van-field v-model="form.fname" label="用户名称" placeholder="请输入用户名称" /> -->
        <!-- <van-field v-model="form.faddr" label="通讯地址" placeholder="请输入用水地址" /> -->
        <van-field v-model="form.fargueno" label="户主身份证" placeholder="请输入用户名称" />
        <van-field v-model="form.fpho" label="联系电话" placeholder="请输入用水地址" />
        <van-field v-model="form.fmoveno" label="接收短信号码" placeholder="请输入用户名称" />
        <van-field v-model="form.fnetmark" rows="2" autosize label="申请说明" type="textarea" maxlength="500" placeholder="请输入备注" show-word-limit />
      </van-cell-group>

      <van-cell-group title="证件资料">
        <van-field required name="uploader" label="产权人身份证(上传正反面2张)">
          <template #input>
            <van-uploader multiple :max-count="2" v-model="cardPositiveMst" :after-read="cardPositiveAfter" @delete="cardPositiveDelete" />
          </template>
        </van-field>
        <van-field name="uploader" label="其他资料">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="otherMst" :after-read="otherAfter" @delete="otherDelete" />
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group title="申请人信息">
        <van-field center clearable label="申请人类别" placeholder="" readonly>
          <template #input>
            <van-radio-group v-model="fnetapplytype" direction="horizontal">
              <van-radio name="1" @click="onChanquanren">产权人</van-radio>
              <van-radio name="2" @click="onShenqingren">申请人</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field :required="shenqingren && active == 0" v-model="form.foper" label="姓名" placeholder="请输入姓名" v-if="shenqingren && active == 0" :rules="[{required: true, message: '请输入姓名'}]" />
        <van-field :required="shenqingren && active == 0" v-model="form.foperidno" label="身份证号" placeholder="请输入身份证号" v-if="shenqingren && active == 0" :rules="[{pattern: $patternId, message: '请输入正确身份证号'}]" />
        <van-field v-model="form.fopertel" label="电话号码" placeholder="请输入电话号码" v-if="shenqingren && active == 0" />
        <van-field required v-model="form.fopermobile" label="手机号码" placeholder="请输入手机号码" :rules="[{pattern: $pattern, message: '请输入正确手机号码'}]" />
        <van-field required v-show="modify" v-model="form.smscode" center clearable label="短信验证" placeholder="请输入短信验证" :rules="[{required: true, message: '请输入短信验证'}]">
          <template #button>
            <sms-btn :phone="form.fopermobile"></sms-btn>
          </template>
        </van-field>
      </van-cell-group>

      <yonghuxuzhi v-show="modify" @changeChecked="changeChecked" :typecode="typecode" :ftrantype="1"></yonghuxuzhi>

      <van-button v-show="modify" :disabled="!checked" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>

    <van-form @submit="unitOnSubmit" v-show="active1 == 1">
      <van-cell-group title="申请信息">
        <van-field readonly required clickable :value="unitForm.fpactno" label="缴费号" placeholder="请选择缴费号" :rules="[{ required: true, message: '点击选择缴费号' }]">
          <template v-if="!$route.query.readonly" #button>
            <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
          </template>
        </van-field>
        <van-field readonly v-model="unitForm.foldname" label="用户名称" />
        <van-field readonly v-model="unitForm.foldaddr" label="用水地址" />
      </van-cell-group>

      <van-cell-group title="变更信息(只需输入更改的信息)">
        <!-- <van-field v-model="unitForm.fname" label="用户名称" placeholder="请输入用户名称" /> -->
        <!-- <van-field v-model="unitForm.faddr" label="通讯地址" placeholder="请输入用水地址" /> -->
        <van-field v-model="unitForm.ftax" label="统一社会信用代码" placeholder="请输入统一社会信用代码" />
        <van-field v-model="unitForm.fpho" label="联系电话" placeholder="请输入用水地址" />
        <van-field v-model="form.fmoveno" label="接收短信号码" placeholder="请输入用户名称" />
        <van-field v-model="unitForm.fnetmark" rows="2" autosize label="申请说明" type="textarea" maxlength="500" placeholder="请输入备注" show-word-limit />
      </van-cell-group>

      <van-cell-group title="证件资料">
        <van-field required name="uploader" label="营业执照（统一社会信用代码）">
          <template #input>
            <van-uploader multiple :max-count="1" v-model="businessLicenseMst" :after-read="businessLicenseAfter" @delete="businessLicenseDelete" />
          </template>
        </van-field>
        <van-field name="uploader" label="其他资料">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="unitotherMst" :after-read="unitotherAfter" @delete="unitotherDelete" />
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group title="申请人信息">
        <van-field required v-model="unitForm.foper" label="姓名" placeholder="请输入姓名" :rules="[{required: true, message: '请输入姓名'}]" />
        <van-field required v-model="unitForm.foperidno" label="身份证号" placeholder="请输入身份证号" :rules="[{pattern: $patternId, message: '请输入正确身份证号'}]" />
        <van-field v-model="unitForm.fopertel" label="电话号码" placeholder="请输入电话号码" />
        <van-field required v-model="unitForm.fopermobile" label="手机号码" placeholder="请输入手机号码" :rules="[{pattern: $pattern, message: '请输入正确手机号码'}]" />
        <van-field required v-show="modify" v-model="unitForm.smscode" center clearable label="短信验证" placeholder="请输入短信验证" :rules="[{required: true, message: '请输入短信验证'}]">
          <template #button>
            <sms-btn :phone="unitForm.fopermobile"></sms-btn>
          </template>
        </van-field>
      </van-cell-group>

      <yonghuxuzhi v-show="modify" @changeChecked="unitChangeChecked" :typecode="typecode" :ftrantype="2"></yonghuxuzhi>

      <van-button v-show="modify" :disabled="!unitChecked" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>

    <van-popup v-model="popShow" class="form-pop">
      <user-select-pop :userList="userList" :isquery="0" @onSelectClick="onSelectClick"></user-select-pop>
    </van-popup>
  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'
import UserSelectPop from '@/components/UserSelectPop.vue'

export default {
  name: 'MeterTransferForm',
  components: {
    smsBtn,
    UserSelectPop
  },
  data() {
    return {
      typecode: 209,
      active: 0,
      active1: 0,
      popShow: false,
      form: {
        ftrantype: 1,
        fsou: this.$comm.titleShow() ? 2 : 4,
        fpactno: '',
        fuserno: '',
        foldname: '',
        foldaddr: '',
        fname: '',
        faddr: '',
        fargueno: '',
        fpho: '',
        fmoveno: '',
        fnetmark: '',
        attach: [],
        fnetapplytype: '1',
        foper: '',
        foperidno: '',
        fopertel: '',
        fopermobile: '',
        smscode: ''
      },
      unitForm: {
        ftrantype: 2,
        fsou: this.$comm.titleShow() ? 2 : 4,
        fpactno: '',
        fuserno: '',
        foldname: '',
        foldaddr: '',
        fname: '',
        faddr: '',
        ftax: '',
        fpho: '',
        fmoveno: '',
        fnetmark: '',
        attach: [],
        fnetapplytype: '2',
        foper: '',
        foperidno: '',
        fopertel: '',
        fopermobile: '',
        smscode: ''
      },
      value: '',
      showPicker: false,
      userList: JSON.parse(localStorage.getItem('userList')),
      userInfo: {},
      isNameSame: false,

      chanquanren: true,
      shenqingren: false,
      // 个人图片资料
      cardPositive: [], // 身份证正面
      cardAnti: [], // 身份证反
      other: [], // 个人其他材料
      cardPositiveMst: [], // 身份证正面
      cardAntiMst: [], // 身份证反
      otherMst: [], // 个人其他材料
      // 单位资料
      businessLicense: [], // 单位营业执照
      unitother: [], // 单位其他材料
      businessLicenseMst: [], // 单位营业执照
      unitotherMst: [], // 单位其他材料
      fnetapplytype: '1',
      flag: this.$route.query.busstype ? false : true,
      modify: this.$route.query.modify ? (this.$route.query.modify === '1' || this.$route.query.modify === 1 ? false : true) : true,
      checked: false,
      unitChecked: false
    }
  },
  mounted() {
    if (!this.flag) {
      this.info()
    }
  },
  methods: {
    changeChecked(checked) {
      this.checked = checked
    },
    unitChangeChecked(checked) {
      this.unitChecked = checked
    },
    // 详情
    info() {
      this.$http.post(this.$api.getBussInfo, {
        busstype: this.$route.query.busstype,
        bussno: this.$route.query.bussno
      }).then(res => {
        if (res.code === '000') {
          // 个人
          if (res.data.ftrantype === 1 || res.data.ftrantype === '1') {
            this.active1 = 0
            this.form = res.data
            if (res.data.fnetapplytype == 1) {
              this.fnetapplytype = '1'
              this.onChanquanren()
            } else {
              this.fnetapplytype = '2'
              this.onShenqingren()
            }
            let result = this.$comm.serviceAttach(res.data)
            // 个人图片资料
            this.cardPositive = result.cardPositive
            this.propertyOwner = result.propertyOwner
            this.other = result.other
            this.cardPositiveMst = result.cardPositiveMst
            this.propertyOwnerMst = result.propertyOwnerMst
            this.otherMst = result.otherMst
          } else {
            // 单位
            this.active1 = 1
            this.unitForm = res.data
            // 单位图片资料
            let result = this.$comm.serviceAttach(res.data)
            this.businessLicense = result.businessLicense
            this.unitpropertyOwner = result.unitpropertyOwner
            this.reply = result.reply
            this.unitother = result.unitother
            this.businessLicenseMst = result.businessLicenseMst
            this.unitpropertyOwnerMst = result.unitpropertyOwnerMst
            this.replyMst = result.replyMst
            this.unitotherMst = result.unitotherMst

          }
          console.log(this.active1)
          this.$clear()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onChanquanren() {
      this.form.fnetapplytype = 1
      this.chanquanren = true
      this.shenqingren = false
    },
    onShenqingren() {
      this.form.foper = this.form.fname
      this.form.fnetapplytype = 2
      this.chanquanren = false
      this.shenqingren = true
    },
    // 身份证正面
    cardPositiveAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.cardPositive.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    cardPositiveDelete(file, detail) {
      this.cardPositive.splice(detail.index, 1)
    },
    // 身份证反面
    cardAntiAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.cardAnti.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    cardAntiDelete(file, detail) {
      this.cardAnti.splice(detail.index, 1)
    },
    // 其他证明
    otherAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.other.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    otherDelete(file, detail) {
      this.other.splice(detail.index, 1)
    },
    // 获取用户信息
    onSelectClick(user) {
      this.popShow = false
      if (this.active1 == 0) {
        this.form.fpactno = user.fpactno
        this.form.fuserno = user.fuserno
        this.form.foldname = user.fname
        this.form.fname = user.fname
        this.form.foldaddr = user.ffixaddr
        this.form.foldwaterid = user.fwaterid
        this.form.foldwater = user.fwater
        this.form.faddr = user.ffixaddr
      } else {
        this.unitForm.fpactno = user.fpactno
        this.unitForm.fuserno = user.fuserno
        this.unitForm.foldname = user.fname
        this.unitForm.fname = user.fname
        this.unitForm.foldaddr = user.ffixaddr
        this.unitForm.foldwaterid = user.fwaterid
        this.unitForm.foldwater = user.fwater
        this.unitForm.faddr = user.ffixaddr
      }
    },
    choiceClick() {
      this.popShow = true
    },
    // 个人提交
    userOnSubmit() {
      this.form.attach = []
      if (this.cardPositive.length <= 0 || this.cardPositive.length < 2) {
        this.$toast('产权人身份证正反面不能为空')
        return
      }
      this.form.attach.push({
        typeid: 1,
        url: this.cardPositive[0].url + ',' + this.cardPositive[1].url
      })
      if (this.other.length > 0) {
        let url = ''
        this.other.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.form.attach.push({
          typeid: 13,
          url: url
        })
      }
      if (this.form.fnetapplytype === '1') {
        this.form.foper = this.form.fname
        console.log(this.form.foper)
      }
      console.log(this.form)
      this.$http.post(this.$api.personChange, this.form).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 营业执照
    businessLicenseAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.businessLicense.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    businessLicenseDelete(file, detail) {
      this.businessLicense.splice(detail.index, 1)
    },
    // 单位其他证明
    unitotherAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.unitother.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    unitotherDelete(file, detail) {
      this.unitother.splice(detail.index, 1)
    },
    // 单位提交
    unitOnSubmit() {
      this.unitForm.attach = []
      if (this.businessLicense.length <= 0) {
        this.$toast('营业执照不能为空')
        return
      }
      this.unitForm.attach.push({
        typeid: 3,
        url: this.businessLicense[0].url
      })
      if (this.unitother.length > 0) { // 单位其他材料
        let url = ''
        this.unitother.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.unitForm.attach.push({
          typeid: 13,
          url: url
        })
      }
      console.log(this.unitForm)
      this.$http.post(this.$api.personChange, this.unitForm).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form {
  /deep/ .van-radio-group.van-radio-group--horizontal {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 33, 33, 1);

    .van-radio--horizontal {
      margin-right: 0;
      margin-left: 4px;

      .van-radio__label {
        margin-left: 2px;
      }
    }
  }

  .form-pop {
    width: 85%;
    height: 60%;
    border-radius: 4px;
    font-size: 12px;
  }
}
</style>